export interface PurchaseOrderLine {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  sequence: number;
  status: string;
  productType: string;
  productId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  quantity: number;
  quantityBase: number;
  received: number;
  receivedBase: number;
  balance: number;
  balanceBase: number;
  allocated: number;
  allocatedBase: number;
  unitOfMeasure: string;
  noOfItems: number;
  price: number;
  lineValue: number;
  urgent: string;
  deliveryDate: Date;
  daysLate: number;
  orderNo: number;
  lineNo: number;
  supplierAccount: string;
  supplierName: string;
  supplierOrderNo: string;
  supplierOrderRef: string;
  dateOrdered: Date;
  orderTypeDescription: string;
  uOM: string;
  delWk: number;
  currencyCode: string;
  currencyValue: number;
  orderLineStatus: string;
  supplierRef: string;
  supplierLineRef: string;
  warehouseId: string;
  contractNo: number;
  colour: string;
  commentsExist: boolean;
}
